import { render } from "./PasswordResetFailedView.vue?vue&type=template&id=be9fe342&scoped=true"
import script from "./PasswordResetFailedView.vue?vue&type=script&lang=js"
export * from "./PasswordResetFailedView.vue?vue&type=script&lang=js"

import "./PasswordResetFailedView.vue?vue&type=style&index=0&id=be9fe342&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be9fe342"]])

export default __exports__